const toDisplayNumber = (input, placeholder = "--") =>
  input != null ? input : placeholder;

export default toDisplayNumber;
